import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle, Activity, Coffee } from 'lucide-react';
const failures = [{
  icon: Activity,
  text: 'Las dietas de 1,200 calorías disparan tu cortisol y destruyen tu musculatura.'
}, {
  icon: AlertCircle,
  text: 'El cardio intenso inflama tus articulaciones y agota tus glándulas adrenales.'
}, {
  icon: XCircle,
  text: 'Los suplementos genéricos no consideran el desorden hormonal de la madurez.'
}, {
  icon: Coffee,
  text: 'Saltarte comidas ralentiza tu tiroides para ahorrar energía.'
}];
export function ProblemContext() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-131">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-132">
        {/* Opening Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-133">
          <p className="text-xl md:text-2xl font-serif italic text-brand-terracotta mb-6" data-id="element-134">
            Te miras al espejo y no te reconoces.
          </p>
          <p className="text-lg text-brand-text/80 leading-relaxed mb-4" data-id="element-135">
            El pantalón que hace un año cerraba perfectamente hoy se siente como
            una tortura. No es falta de voluntad, no es que estés comiendo
            "demasiado". Es tu cuerpo enviando una señal de socorro.
          </p>
          <p className="text-lg text-brand-text/80 leading-relaxed font-medium" data-id="element-136">
            A los 45+, las reglas del juego cambian. Tu cuerpo ya no responde a
            las dietas de hambre ni a las horas de cardio; responde a tus
            hormonas.
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 mb-16 shadow-sm border border-brand-accent/50" data-id="element-137">
          <h2 className="text-3xl font-bold mb-6 text-center" data-id="element-138">
            La "Tormenta Perfecta"
          </h2>
          <p className="text-lg text-brand-text/80 leading-relaxed mb-4" data-id="element-139">
            Después de los 45, la caída del estrógeno y el aumento del cortisol
            crean la "tormenta perfecta". Tu metabolismo entra en modo de
            supervivencia.
          </p>
          <p className="text-lg text-brand-text/80 leading-relaxed mb-4" data-id="element-140">
            En este estado, cada ensalada triste que comes y cada kilómetro que
            corres solo estresa más a tu cuerpo, dándole la orden directa de
            almacenar grasa precisamente en el abdomen para "protegerte".
          </p>
          <p className="text-lg text-brand-terracotta font-semibold leading-relaxed text-center mt-6" data-id="element-141">
            Por eso te sientes cansada, inflamada y frustrada. Estás peleando
            contra tu propia biología.
          </p>
        </motion.div>

        {/* Why What You Tried Didn't Work */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-142">
          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-143">
            Por qué lo que has intentado no funciona
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-144">
            {failures.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-6 rounded-2xl bg-white border border-brand-accent/30 shadow-sm" data-id="element-145">
                <div className="flex-shrink-0 p-2 bg-brand-terracotta/10 rounded-full text-brand-terracotta" data-id="element-146">
                  <item.icon className="w-6 h-6" data-id="element-147" />
                </div>
                <p className="text-brand-text/80 leading-relaxed" data-id="element-148">
                  {item.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}